"use client";

import { Building2, Globe, LayoutDashboard, Radar, Trophy } from "lucide-react";
import { LiquidPill, LiquidPillGroup, type LiquidPillGroupItem } from "components/ui/v2";
import { PageShell } from "components/ui/v2/layout/page-shell";
import useTranslation from "next-translate/useTranslation";
import { useMemo, useState } from "react";
import { DashboardOrganizationAllPanelV2 } from "./DashboardOrganizationAllPanelV2";
import { DashboardOrganizationRankingPanelV2 } from "./DashboardOrganizationRankingPanelV2";
import { DashboardOrganizationTechRadarPanelV2 } from "./DashboardOrganizationTechRadarPanelV2";

type TTab = "all" | "ranking" | "techRadar";

export function DashboardOrganizationPageV2() {
  const { t } = useTranslation("common");
  const [tab, setTab] = useState<TTab>("all");

  const tabItems = useMemo(
    (): LiquidPillGroupItem[] => [
      { value: "all", label: t("Toda la organización"), icon: <Globe className="h-3.5 w-3.5" />, variant: "indigo" },
      { value: "ranking", label: t("Ranking"), icon: <Trophy className="h-3.5 w-3.5" />, variant: "gold" },
      { value: "techRadar", label: t("Tech Radar"), icon: <Radar className="h-3.5 w-3.5" />, variant: "sky" },
    ],
    [t]
  );

  return (
    <PageShell
      header={{
        title: t("Dashboard organizacional"),
        description: t(
          "Indicadores de personas, metas, planes de desarrollo y evaluaciones de tu organización"
        ),
        leadingIcon: (
          <Building2 className="h-10 w-10 shrink-0 text-indigo-600 dark:text-indigo-300" />
        ),
        particleIcon: Building2,
        badges: (
          <>
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              shadow="neutral"
              size="sm"
              icon={<LayoutDashboard className="h-4 w-4" />}
              text={<><span className="font-semibold text-current">3</span> {t("vistas")}</>}
            />
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              shadow="neutral"
              size="sm"
              icon={<Trophy className="h-4 w-4" />}
              text={t("Ranking")}
            />
            <LiquidPill
              variant="indigo"
              appearance="tinted"
              shadow="neutral"
              size="sm"
              icon={<Radar className="h-4 w-4" />}
              text={t("Tech Radar")}
            />
          </>
        ),
      }}
      toolbar={
        <LiquidPillGroup
          items={tabItems}
          activeValue={tab}
          onChange={(value) => setTab(value as TTab)}
          size="sm"
        />
      }
    >
      {tab === "all" && <DashboardOrganizationAllPanelV2 />}
      {tab === "ranking" && <DashboardOrganizationRankingPanelV2 />}
      {tab === "techRadar" && <DashboardOrganizationTechRadarPanelV2 />}
    </PageShell>
  );
}
